// 404.js
import React, { useState, useEffect } from "react";
import Link from "next/link";
import Head from "next/head";
import Header from "../components/common/header";
import Footer from "../components/common/footer";
// Custom NPM Package
import {
  BackToTopButton,
  CookieBanner,
} from "@benchvondaranch/npm.react-ui-library";
import variables from "../styles/variables.module.scss";
//Load Styles
import styles from "../styles/pages/CourseDates.module.scss";
//i18n
import { useTranslation } from "react-i18next";
// Using Global Redux State
import { useSelector, useDispatch } from "react-redux";
import { updateLocalStorage } from "../store/userSlice";
import {
  Container,
  Row,
  Col,
  Card,
  Placeholder,
  Button,
} from "react-bootstrap";
import { getReadableStringOfDate } from "../utils/generalHelper";


function sortObjectsByDateAscending(objects, dateAttribute) {
  // Sort the objects based on the specified date attribute
  objects.sort((a, b) => {
      const dateA = new Date(a.attributes[dateAttribute]);
      const dateB = new Date(b.attributes[dateAttribute]);
      return dateA - dateB;
  });

  return objects;
}

export default function Courses() {
  const [isLoading, setIsLoading] = useState(true); //for test
  const { t, i18n } = useTranslation();
  const [coursesData, setCoursesfData] = useState({});
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  const dispatch = useDispatch();

  const getCoursesData = async () => {
    try {
      const response = await fetch(
        `/api/backend/courses?locale=${i18n.language}`,
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      const dataFromBackend = await response.json();
   
      // Sort by X
      const sortedObjects = sortObjectsByDateAscending(dataFromBackend, "date");

      setCoursesfData(sortedObjects);
    } catch (error) {
      console.log("[Error - loading Settings] - " + error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    async function fetchDataFromNextAPI() {
      getCoursesData();
    }
    fetchDataFromNextAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cookie Banner START
  // Check if the user already agreed to the GDPCR - Cookie Banner
  useEffect(() => {
    if (typeof window !== "undefined") {
      const cookieBannerDataFromLocalStorage = localStorage.getItem(
        "cookieBannerData"
      )
        ? JSON.parse(localStorage.getItem("cookieBannerData"))
        : undefined;

      if (cookieBannerDataFromLocalStorage?.accepted === "true") {
        setShowCookieBanner(false);
      } else {
        setShowCookieBanner(true);
      }
    }
  }, []);

  const selectAll = (e) => {
    const cookieData = {
      necessary: "true",
      marketing: "true",
      performance: "true",
      accepted: "true",
      acceptedDateTime: `${new Date()}`,
      savedViaButtonAction: `${e.target.getAttribute("data-c-action")}`,
    };
    localStorage.setItem("cookieBannerData", JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData));
    setShowCookieBanner(false);
  };
  const saveSelection = (e) => {
    // Get All Checkboxes of CookieBanner
    const cbNecessary = document.getElementById("necessary").checked;
    const cbMarketing = document.getElementById("marketing").checked;
    const cbPerformance = document.getElementById("performance").checked;
    const cookieData = {
      necessary: `${cbNecessary}`,
      marketing: `${cbMarketing}`,
      performance: `${cbPerformance}`,
      accepted: "true",
      acceptedDateTime: `${new Date()}`,
      savedViaButtonAction: `${e.target.getAttribute("data-c-action")}`,
    };
    localStorage.setItem("cookieBannerData", JSON.stringify(cookieData));
    dispatch(updateLocalStorage(cookieData));
    setShowCookieBanner(false);
  };
  // Cookie Banner END
  if (isLoading===true) return null;
  
  return (
    <>
      <Head>
        <title>{t("meta_tag_coursedates_page_title")}</title>
        <meta name="robots" content="noindex" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <Header />
      <Container className="pt-0" fluid>
        <Row
          className="justify-content-center webpageTitle"
          style={{
            backgroundColor:
              variables.initial_standardHeaderBanner_backgroundColor,
            color: variables.initial_standardHeaderBanner_fontColor,
          }}
        >
          <Col></Col>
          <Col  xs={'auto'} sm={'auto'} md={'auto'}  lg={'auto'}  xl={'auto'}>
            <h2>{t("page_coursedates_banner_h1")}</h2>
          </Col>
          <Col></Col>
        </Row>
      </Container>
      <Container style={{ maxWidth: "100%" }}>
        <Row className="text-center">
          <Col md="12" className="p-0">
            <div className="padding80"></div>
            <div className="section-full p-tb80 inner-page-padding ">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <div className={`${styles["concerts"]}`}>
                      {/* <h3>Kurstermine</h3> */}
                      <ul className="footer-lists op-text">
                        {coursesData.length > 0
                          ? coursesData.map((data, i) => {
                              return (
                                <Container fluid="sm" key={i}>
                                  <Row
                                    xs="2"
                                    sm="1"
                                    md="2"
                                    className={`${styles["courselist-item"]}`}
                                  >
                                    <Col xs="6" sm="4" md="2">
                                      <div
                                        className={`${styles["field__items"]} ${styles["date_field"]}`}
                                      >
                                        <div
                                          className={`${styles["field__item"]}`}
                                        >
                                          <h6>Kursstart:</h6>
                                          <span
                                            data-date-format="mmm"
                                            className={`${styles["month"]}`}
                                          >
                                            {getReadableStringOfDate(
                                              data.attributes.date,
                                              "LLLL"
                                            )}
                                          </span>
                                        </div>
                                        <div
                                          className={`${styles["field__item"]}`}
                                        >
                                          <span
                                            data-date-format="j"
                                            className={`${styles["day"]}`}
                                          >
                                            {getReadableStringOfDate(
                                              data.attributes.date,
                                              "dd"
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs="6" sm="8" md="6">
                                      <div
                                        className={`${styles["field__items"]}`}
                                      >
                                        <div
                                          className={`${styles["field__item"]}`}
                                        >
                                          <span
                                            className={`${styles["locality"]}`}
                                          >
                                            <b> {data.attributes.title}</b>
                                          </span>
                                          <br></br>
                                          <span
                                            className={`${styles["locality"]}`}
                                          >
                                            Beginn:{" "}
                                            {getReadableStringOfDate(
                                              data.attributes.time,
                                              "HH:mm"
                                            )}{" "}
                                            Uhr{" "}
                                          </span>
                                          <span
                                            className={`${styles["locality"]}`}
                                          >
                                            {data.attributes.duration}
                                          </span>
                                          <br></br>
                                          <span
                                            className={`${styles["locality"]}`}
                                          >
                                            Kosten: {data.attributes.price} €
                                          </span>
                                          <br></br>
                                          <a
                                            href={
                                              data.attributes.course_info_url
                                            }
                                            target="_blank"
                                            className={`${styles["courseInfoURL"]}`}
                                          >
                                            Kursinfo
                                          </a>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs="4" sm="4" md="4" lg="2">
                                      <span
                                      className={`${styles["dates"]}`}
                                      >Termine:</span>
                                      {data.attributes.dates.map(
                                        (option, j) => (
                                          <div key={j}>
                                            <span
                                              className={`${styles["locality"]}`}
                                            >
                                              {getReadableStringOfDate(
                                                option.start_date,
                                                "dd.MMMyyyy"
                                              )}
                                            </span>
                                          </div>
                                        )
                                      )}
                                          <br></br>
                                    </Col>
                                    <Col xs="8" sm="8" md="4" lg="2">
                                    <a
                                          href={data.attributes.register_url}
                                          target="_blank"
                                          className={`${styles["ticketurl1"]}`}
                                        >
                                      <div
                                        className={`${styles["field__item"]} ${styles["ticketurlfield"]}`}
                                      >
                                       <span  className={`${styles["ticketurl1"]}`}> {t(
                                            "page_coursedates_text_registration"
                                          )}</span>
                                         
                                    
                                      </div>
                                      </a>
                                    </Col>
                                  </Row>
                                </Container>
                              );
                            })
                          : t("page_coursedates_error_nodataloaded")}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <BackToTopButton
      backgroundColor={variables.initial_backToTop_backgroundColor}
      borderColor='white'
      borderWidth='2px'
      width='40px'
      height='40px'
      iconColor='white'
      iconType={1}
      iconMarginTop='-10px'/>
      <Footer />

      <CookieBanner
        title={t("cookie_banner_title")}
        subtitle={t("cookie_banner_subtitle")}
        description={t("cookie_banner_description")}
        text_save_selection={t("cookie_banner_text_save_selection")}
        text_accept_all={t("cookie_banner_text_accept_all")}
        text_checkbox_option1={t("cookie_banner_text_checkbox_option1")}
        text_checkbox_option2={t("cookie_banner_text_checkbox_option2")}
        text_checkbox_option3={t("cookie_banner_text_checkbox_option3")}
        gdpr_link={t("cookie_banner_gdpr_link")}
        gdpr_link_text={t("cookie_banner_gdpr_link_text")}
        imprint_link={t("cookie_banner_imprint_link")}
        imprint_link_text={t("cookie_banner_imprint_link_text")}
        display={showCookieBanner}
        handleAcceptAllClick={selectAll}
        handleSaveSelectionClick={saveSelection}
      ></CookieBanner>
    </>
  );
}
